module.exports = __webpack_public_path__ + "assets/0103_IFOK_WIM_MARKER_yellow_news_je.7f903f40.svg";